<template>
    <div class="info-wrap py-5">
        <div class="container">
            <div class="row align-items-center mb-2 section-row">
        <div class="col-md-6 order-md-2">
          <img src="../../assets/images/photo 15.jpg" alt="Mission" class="section-img">
        </div>
        <div class="col-md-6">
          <!-- <h3 class="section-title">Mission</h3> --> <br><br>
          <p class="section-text">
           L’Évangile, quand il imprègne vraiment les cœurs et mentalités, provoque une véritable metanoia personnelle et collective d’une part ; et surtout fait éclore les diverses potentialités culturelles à la hauteur des divers enjeux. L’effectivité de cette mission requiert aussi une certaine connaissance du Logos, au nom même de la relation interne et intime entre foi et raison (Cf. Fides et Ratio, n° 1 ; intellego ut credam et credo ut intellegam). Les deux assemblées du synode spécial pour l’Afrique (1994 et 2009) ont vivement rappelé l’urgence et la nécessité de la formation chrétienne, à travers leurs exhortations respectives.
Entre autres, Ecclesia in Africa, n° 54 lançait cette interrogation, encore toute pertinente :  « L’Église en Afrique a-t-elle formé suffisamment les laïcs, pour les rendre capables d’assumer toutes leurs responsabilités civiques et de réfléchir sur les affaires d’ordre socio-politique à la lumière de l’Évangile et de la foi en Dieu ? ». Pour sa part, Africӕ munus, n° 137 invitait expressément à « une pastorale de l’intelligence et de la raison qui crée une habitude de dialogue rationnel et d’analyse critique dans la société et dans l’Église » (Africæ munus, n° 137). Par ailleurs, lors de la dernière visite “ad limina apostolorum” des évêques du Bénin à Rome (27 avril 2015), le pape François déclarait qu’« il est important que le désir d’une connaissance profonde du mystère chrétien ne soit pas l’apanage d’une élite, mais anime tous les fidèles, car tous sont appelés à la sainteté ».

            <!-- Texte complet ici -->
          </p>
        </div>
      </div>

        </div>


    </div>
</template>

<style scoped>
.info-wrap {
  background-color: #f8f9fa;
}

.section-row {
  padding: 20px 0;
}

.section-img {
  width: 100%;
  border-radius: 15px;
  box-shadow: 0 5px 15px rgba(0,0,0,0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.section-img:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 25px rgba(0,0,0,0.2);
}

.section-title {
  font-size: 1.8rem;
  font-weight: 700;
  color: #0b1b3f;
  margin-bottom: 15px;
}

.section-text {
  font-size: 1rem;
  color: #6c757d;
  line-height: 1.7;
  text-align: justify;
}

.btn-download {
  background-color: #ffc107;
  color: #0b1b3f;
  font-weight: 700;
  padding: 12px 25px;
  border: none;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn-download:hover {
  background-color: #e0a800;
  transform: translateY(-2px);
}


</style>
